import { apiRoutes } from "../services/apiRoutes";
import { DateFormater } from "../services/DateFormater";

export const FilterData = (props) => {
    const { adjustForTimezone } = DateFormater();

    const getFilterData = async (groups) => {
        let json = await props.execute("GET", apiRoutes.filter.GetFilters);
        let filters = json.map(x => {
            if (x.timestampModified != null) {
                x.timestampModifiedDisplay = adjustForTimezone(x.timestampModified, props.customer.TimezoneId ?? 0);
                x.timestampModified = adjustForTimezone(x.timestampModified, props.customer.TimezoneId ?? 0);
            }

            x.customerPortal = x.publicSiteFilters.map(y => y.publicSite.name).join(", ");
            x.groups = x.customerGroupFilters.map(y => groups.find(z => z.value === y.groupId).label).join(", ");

            return x;
        });

        return filters;
    }

    const getUserGroups = async () => {
        let json = await props.execute("GET", apiRoutes.filter.groups);
        for (var i = 0; i < json.length; i++) {
            json[i].value = json[i].id;
            json[i].label = json[i].name;
        }
        return json;
    }

    const deleteFilter = async (filterId) => {
        await props.execute("DELETE", apiRoutes.filter.delete(filterId));
    }

    const postFilter = async (selectedFilter, localesSelected, IncludeExclude) => {
        selectedFilter.searchMaterialFilters = [];

        localesSelected.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].LanguageId = x.value;
        });

        IncludeExclude.ExactMatchInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].ExactMatchInclude = x;
        });
        IncludeExclude.Cc1Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc1Include = x;
        });
        IncludeExclude.Cc2Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc2Include = x;
        });
        IncludeExclude.Cc3Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc3Include = x;
        });
        IncludeExclude.MfgInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].MfgInclude = x;
        });
        IncludeExclude.TagInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].TagInclude = x;
        });
        IncludeExclude.ExactMatchExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].ExactMatchExclude = x;
        });
        IncludeExclude.Cc1Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc1Exclude = x;
        });
        IncludeExclude.Cc2Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc2Exclude = x;
        });
        IncludeExclude.Cc3Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cc3Exclude = x;
        });
        IncludeExclude.MfgExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].MfgExclude = x;
        });
        IncludeExclude.TagExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].TagExclude = x;
        });
        IncludeExclude.Cd1Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd1Include = x;
        });
        IncludeExclude.Cd2Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd2Include = x;
        });
        IncludeExclude.Cd3Include.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd3Include = x;
        });
        IncludeExclude.Cd1Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd1Exclude = x;
        });
        IncludeExclude.Cd2Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd2Exclude = x;
        });
        IncludeExclude.Cd3Exclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].Cd3Exclude = x;
        });
        IncludeExclude.DocTypeInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].DocumentTypeInclude = x;
        });
        IncludeExclude.DocTypeExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].DocumentTypeExclude = x;
        });
        IncludeExclude.DocFormatInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].DocumentFormatInclude = x;
        });
        IncludeExclude.DocFormatExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].DocumentFormatExclude = x;
        });
        IncludeExclude.LocationInclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].LocationInclude = x;
        });
        IncludeExclude.LocationExclude.forEach((x, index) => {
            if (selectedFilter.searchMaterialFilters[index] == null)
                selectedFilter.searchMaterialFilters[index] = {};
            selectedFilter.searchMaterialFilters[index].LocationExclude = x;
        });

        await props.execute("POST", apiRoutes.filter.post(), selectedFilter);
    }

    const assignFilterToSites = async (sitesSelected, filterId) => {
        let siteIds = sitesSelected.map(x => x.value).join(",");
        if (siteIds === "")
            siteIds = null;
        await props.execute("POST", apiRoutes.filter.AssignFilterToSites(filterId), siteIds);
    }

    const assignFilterToGroups = async (groupsSelected, filterId) => {
        let groupIds = groupsSelected.map(x => x.value).join(",");
        if (groupIds === "")
            groupIds = null;
        await props.execute("POST", apiRoutes.filter.AssignFilterToGroups(filterId), groupIds );
    }

    const getFilter = (filterId, originalfilters, localesDropdownData) => {
        let filter = originalfilters.filter(x => x.id === filterId);
        if (filter.length > 0)
            filter = JSON.parse(JSON.stringify(filter[0]));
        else
            filter = {};
            
        let lSelected = [];

        let ExactMatchInclude = [];
        let Cc1Include = [];
        let Cc2Include = [];
        let Cc3Include = [];
        let MfgInclude = [];
        let TagInclude = [];
        let ExactMatchExclude = [];
        let Cc1Exclude = [];
        let Cc2Exclude = [];
        let Cc3Exclude = [];
        let MfgExclude = [];
        let TagExclude = [];
        let Cd1Include = [];
        let Cd2Include = [];
        let Cd3Include = [];
        let Cd1Exclude = [];
        let Cd2Exclude = [];
        let Cd3Exclude = [];
        let DocTypeInclude = [];
        let DocTypeExclude = [];
        let DocFormatInclude = [];
        let DocFormatExclude = [];
        let LocationInclude = [];
        let LocationExclude = [];

        filter.searchMaterialFilters.forEach(x => {
            if (x.tagExclude != null)
                TagExclude.push(x.tagExclude);
            if (x.mfgExclude != null)
                MfgExclude.push(x.mfgExclude);
            if (x.cc3exclude != null)
                Cc3Exclude.push(x.cc3exclude)
            if (x.cc2exclude != null)
                Cc2Exclude.push(x.cc2exclude);
            if (x.cc1exclude != null)
                Cc1Exclude.push(x.cc1exclude);
            if (x.exactMatchExclude != null)
                ExactMatchExclude.push(x.exactMatchExclude)
            if (x.tagInclude != null)
                TagInclude.push(x.tagInclude);
            if (x.mfgInclude != null)
                MfgInclude.push(x.mfgInclude);
            if (x.cc3include != null)
                Cc3Include.push(x.cc3include);
            if (x.cc2include != null)
                Cc2Include.push(x.cc2include);
            if (x.cc1include != null)
                Cc1Include.push(x.cc1include);
            if (x.exactMatchInclude != null)
                ExactMatchInclude.push(x.exactMatchInclude);
            if (x.languageId != null) {
                let item = localesDropdownData.filter(y => y.languageId == x.languageId)[0];
                lSelected.push(item);
            }
            if (x.cd3include != null) Cd3Include.push(x.cd3include);
            if (x.cd2include != null) Cd2Include.push(x.cd2include);
            if (x.cd1include != null) Cd1Include.push(x.cd1include);
            if (x.cd3exclude != null) Cd3Exclude.push(x.cd3exclude)
            if (x.cd2exclude != null) Cd2Exclude.push(x.cd2exclude);
            if (x.cd1exclude != null) Cd1Exclude.push(x.cd1exclude);
            if (x.documentTypeInclude != null) DocTypeInclude.push(x.documentTypeInclude);
            if (x.documentTypeExclude != null) DocTypeExclude.push(x.documentTypeExclude);
            if (x.documentFormatInclude != null) DocFormatInclude.push(x.documentFormatInclude);
            if (x.documentFormatExclude != null) DocFormatExclude.push(x.documentFormatExclude);
            if (x.locationInclude != null) LocationInclude.push(x.locationInclude);
            if (x.locationExclude != null) LocationExclude.push(x.locationExclude);
        });

        return {
            lSelected,
            includeExcludeValues: {
                Cd1Include, Cd2Include, Cd3Include, Cd1Exclude, Cd2Exclude, Cd3Exclude, DocTypeInclude, DocTypeExclude,
                Cc1Include, Cc2Include, Cc3Include, MfgInclude, TagInclude, DocFormatInclude, DocFormatExclude, LocationInclude, LocationExclude,
                ExactMatchInclude, ExactMatchExclude, Cc1Exclude, Cc2Exclude, Cc3Exclude, MfgExclude, TagExclude
            }, filter
        };
    }

    const getFilterTitles = (columns) => {
        let tags = columns.find(x => x.field === "materialTagsText").Title;
        let mfg = columns.find(x => x.field === "documentManufacturer").Title;
        let cc1 = columns.find(x => x.field === "textValue1").Title;
        let cc2 = columns.find(x => x.field === "textValue2").Title;
        let cc3 = columns.find(x => x.field === "textValue3").Title;
        let cd1 = columns.find(x => x.field === "documentText1").Title;
        let cd2 = columns.find(x => x.field === "documentText2").Title;
        let cd3 = columns.find(x => x.field === "documentText3").Title;
        let Location = columns.find(x => x.field === "regulatoryJurisdiction").Title;
        let DocType = columns.find(x => x.field === "documentType").Title;
        let DocFormat = columns.find(x => x.field === "documentFormat").Title;

        return { tags, mfg, cc1, cc2, cc3, cd1, cd2, cd3, Location, DocType, DocFormat };
    }

    return {
        getFilterTitles, getFilterData, deleteFilter, postFilter, assignFilterToSites, assignFilterToGroups, getUserGroups, getFilter
    };
}